import { render } from "./birdsGroomingBannerComponent.vue?vue&type=template&id=796ee5be"
import script from "./birdsGroomingBannerComponent.vue?vue&type=script&lang=js"
export * from "./birdsGroomingBannerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__